export const numberOfDays = 365;
